export enum ValidationKeys {
  BACKSPACE = 'Backspace',
  DELETE = 'Delete',
}
